<script>

export default {
	name: 'CheckboxTableSelectAll',
	
	components: {
	
	},
	
	data() {
		return {
			datas:[],
			checkAllItems:false
		}
	},
	
	props: {'selectedItemStore': Object, 'allSelectedItems': Array, 'dataList': Array },
	emits: ['changeSelected'],

	mounted:function(){
		this.datas=this.dataList;
		this.checkCountSelected();
	},
	
	methods: {
		handleClick(){
			if(this.checkAllItems){
				for(let i = 0; i < this.datas.length; i++){
					this.datas[i].selectedId=true;
					if(this.allSelectedItems.indexOf(this.datas[i].id)==-1){
						this.selectedItemStore.addSelectedItems(this.datas[i].id);
					}
				}
			}else{
				for(let i = 0; i < this.datas.length; i++){
					this.datas[i].selectedId=false;
					var indexToRemove = this.allSelectedItems.indexOf(this.datas[i].id);
					if(indexToRemove>=0){
						this.selectedItemStore.deleteSelectedItems(indexToRemove);
					}
				}
			}
			this.$emit('changeSelected',this.datas)
		},

		checkCountSelected(){
			const filteredDatas = this.dataList.filter((item) => item.selectedId === true);
			if(filteredDatas.length==this.dataList.length){
				this.checkAllItems=true;
			}else{
				this.checkAllItems=false;
			}
		}
	},	
	
	watch: {
		dataList() {
			this.datas=this.dataList;
			this.checkCountSelected();
		},
	},

	computed:{
		
	},
	
}
</script>

<template>
	<div>
		<div class="form-check"><label class="form-check-label"><input v-model="checkAllItems" v-on:change="handleClick()" class="form-check-input" type="checkbox"><span class="form-check-sign"><span class="check"></span></span></label></div>
	</div>
</template>


